import { createFileRoute } from '@tanstack/react-router'
import { InviteDialogPending } from '@/routes/_app/-components/shared/dialog-pending'
import { idParams, useModalSlot } from '@/components/custom/modal-slot'
import InviteDialog from '@/routes/_app/-dialogs/invite'

export const Route = createFileRoute('/@modal/offers/$offerId/invite')({
  params: idParams('offerId'),
  staticData: { slotScope: '/_app' },
  pendingComponent: InviteDialogPending,
  component: InviteSlot,
})

function InviteSlot() {
  const { params, ...slot } = useModalSlot(Route)
  return <InviteDialog offerId={Number(params.offerId)} {...slot} />
}
